export default "__VITE_ASSET__BzgQuf4A__"